// src/icons/DiscordIcon.js
import React from 'react';

const DiscordIcon = ({ size = 24, color = "currentColor" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill={color}
    >
        <path d="M20.317 4.369a19.791 19.791 0 00-4.885-1.514.073.073 0 00-.078.037 13.92 13.92 0 00-.602 1.235 18.02 18.02 0 00-5.419 0 13.896 13.896 0 00-.603-1.235.074.074 0 00-.078-.037 19.793 19.793 0 00-4.885 1.514.07.07 0 00-.032.027C.533 9.194-.32 13.898.099 18.545a.08.08 0 00.031.052 19.96 19.96 0 005.996 3.032.074.074 0 00.082-.027 13.294 13.294 0 001.094-1.785.075.075 0 00-.041-.106 13.144 13.144 0 01-1.872-.901.077.077 0 01-.008-.127 10.067 10.067 0 00.374-.293.073.073 0 01.077-.01c3.927 1.804 8.18 1.804 12.061 0a.074.074 0 01.078.009c.123.1.25.2.374.294a.075.075 0 01-.006.127 12.951 12.951 0 01-1.873.9.075.075 0 00-.04.107 13.212 13.212 0 001.094 1.784.075.075 0 00.081.028 19.942 19.942 0 005.998-3.032.077.077 0 00.031-.052c.5-5.086-.838-9.762-3.992-14.149a.07.07 0 00-.032-.028zM8.02 15.331c-1.182 0-2.153-1.085-2.153-2.419 0-1.333.957-2.419 2.153-2.419 1.211 0 2.182 1.1 2.153 2.42 0 1.333-.957 2.418-2.153 2.418zm7.979 0c-1.183 0-2.153-1.085-2.153-2.419 0-1.333.957-2.419 2.153-2.419 1.211 0 2.182 1.1 2.153 2.42 0 1.333-.942 2.418-2.153 2.418z" />
    </svg>
);

export default DiscordIcon;
